import { Component, Input } from '@angular/core';

export type SkeletonType = 'template-card' | 'project-row' | 'stat-card' | 'rect' | 'text';

@Component({
    selector: 'app-skeleton-loader',
    templateUrl: './skeleton-loader.component.html',
    styleUrls: ['./skeleton-loader.component.scss'],
})
export class SkeletonLoaderComponent {
    @Input() type: SkeletonType = 'rect';
    @Input() width: string = '100%';
    @Input() height: string = '100%';
    @Input() set count(value: number) {
        this.items = Array(value).fill(0);
    }
    items: number[] = [0];
}
